var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-4"},[_vm._v("404: "+_vm._s(_vm._f("translate")('Page not found.')))]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name: 'index'}}},[_vm._v(_vm._s(_vm._f("translate")('Back to homepage.')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }